// removed by extract-text-webpack-plugin
module.exports = {"root":"TabPartList-module-root-3zZt_","part-item":"TabPartList-module-part-item-2UsIA","partItem":"TabPartList-module-part-item-2UsIA"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Product/components/TabPartList/TabPartList.module.scss
// module id = 1251
// module chunks = 0